import React from 'react';
import SolutionTempWrapper from 'components/SolutionTempWrapper';

export default function SolutionTempContainer() {

  return (
    <SolutionTempWrapper />
  )
}
